export const FETCH_TRACKED_KEYWORDS_IN_PROGRESS = "FETCH_TRACKED_KEYWORDS_IN_PROGRESS";
export const FETCH_TRACKED_KEYWORDS_SUCCESSFUL = "FETCH_TRACKED_KEYWORDS_SUCCESSFUL";
export const FETCH_TRACKED_KEYWORDS_FAILED = "FETCH_TRACKED_KEYWORDS_FAILED";

export const FETCH_TRACKED_KEYWORDS_COUNT_IN_PROGRESS = "FETCH_TRACKED_KEYWORDS_COUNT_IN_PROGRESS";
export const FETCH_TRACKED_KEYWORDS_COUNT_SUCCESSFUL = "FETCH_TRACKED_KEYWORDS_COUNT_SUCCESSFUL";
export const FETCH_TRACKED_KEYWORDS_COUNT_FAILED = "FETCH_TRACKED_KEYWORDS_COUNT_FAILED";

export const FETCH_TOP_DOMAINS_IN_PROGRESS = "FETCH_TOP_DOMAINS_IN_PROGRESS";
export const FETCH_TOP_DOMAINS_SUCCESSFUL = "FETCH_TOP_DOMAINS_SUCCESSFUL";
export const FETCH_TOP_DOMAINS_FAILED = "FETCH_TOP_DOMAINS_FAILED";

export const FETCH_KEYWORD_OVERVIEW_IN_PROGRESS = "FETCH_OVERVIEW_IN_PROGRESS";
export const FETCH_KEYWORD_OVERVIEW_SUCCESSFUL = "FETCH_OVERVIEW_SUCCESSFUL";
export const FETCH_KEYWORD_OVERVIEW_FAILED = "FETCH_OVERVIEW_FAILED";

export const CHANGE_SEO_DB_IN_PROGRESS = "CHANGE_SEO_DB_IN_PROGRESS";
export const CHANGE_SEO_DB_SUCCESSFUL = "CHANGE_SEO_DB_SUCCESSFUL";
export const CHANGE_SEO_DB_FAILED = "CHANGE_SEO_DB_FAILED ";

export const DELETE_KEYWORD_IN_PROGRESS = "DELETE_KEYWORD_IN_PROGRESS ";
export const DELETE_KEYWORD_SUCCESSFUL = "DELETE_KEYWORD_SUCCESSFUL";
export const DELETE_KEYWORD_FAILED = "DELETE_KEYWORD_FAILED";

export const ADD_KEYWORDS_IN_PROGRESS = "ADD_KEYWORDS_IN_PROGRESS ";
export const ADD_KEYWORDS_SUCCESSFUL = "ADD_KEYWORDS_SUCCESSFUL";
export const ADD_KEYWORDS_FAILED = "ADD_KEYWORDS_FAILED";
